//@flow
const styles = {
    textFieldStyle: {
        width: '310px',
        paddingBottom: '10px'
    },
    numberFieldStyle: {
        width: '150px',
        paddingBottom: '10px'
    }
}

export default styles


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/common/styles.js